const ratio: { [icon: string]: { [option: string]: number } } = {
  bookmark: {
    width: 20,
    height: 21
  },
  images: {
    width: 36,
    height: 32
  },
  sendMail: {
    width: 24,
    height: 12.2
  },
  logo: {
    width: 1362.3,
    height: 328.8
  },
  logo_fr: {
    width: 1362.3,
    height: 328.8
  },
  logo_mobile: {
    width: 1362.3,
    height: 236.9
  }
};

export default ratio;
